import * as types from '../types';
import * as config from '../config';

import firebase from "firebase";
import axios from 'axios'
const _ = require('lodash');

const PLAYER_DATA_PARSE_KEYS = [
    'gameconfig',
    'avatarconfig',
    'progress',
    'virtualassets',
]

const parsePlayerDataToJSON = function(playerData) {
    const parsedObj = { ...playerData }
    PLAYER_DATA_PARSE_KEYS.forEach((key) => {
        parsedObj[key] = JSON.stringify(playerData[key])
    })
    return parsedObj
}

const parsePlayerDataFromJSON = function(playerData) {
    const parsedObj = { ...playerData }
    PLAYER_DATA_PARSE_KEYS.forEach((key) => {
        parsedObj[key] = JSON.parse(playerData[key])
    })
    return parsedObj
}

const state = {
    user: {
        loggedIn: false,
        data: null,
        playerDatas: null,
    }
};

const getters = {
    [types.GET_USER]: state => {
        return state.user
    }    
};

const mutations = {
    [types.SET_LOGGED_IN]: (state, payload) => {      
        state.user.loggedIn = payload;
    },
    [types.SET_USER_DATA]: (state, payload) => {        
        state.user.data = payload;
    },
    [types.SET_PLAYER_DATA]: (state, payload) => {        
        state.user.playerDatas = payload;
    },
};

const actions = {
    [types.FETCH_USER_ASYNC]: ({ commit, dispatch }, payload) => {
        const user = payload;      
        if (!user) {
            commit(types.SET_LOGGED_IN, false);
            commit(types.SET_USER_DATA, null);
            return new Promise((resolve, reject) => { resolve() });
        }

        return new Promise((resolve, reject) => {
            const forceRefresh = true;
            let accessToken = "";
            firebase.auth().currentUser.getIdToken(forceRefresh)
            .then(function(idToken) {
                accessToken = idToken;
                axios.post(
                    config.BASE_URL + "/users", 
                    {
                        'email': user.email,
                        'username': user.displayName,
                    },
                    config.JSON_HEADER_CONFIG_BEARER(accessToken)
                )
                .then((res) => {
                    console.log(res);

                    commit(types.SET_LOGGED_IN, true);
                    commit(types.SET_USER_DATA, {
                        uid: user.uid,
                        refreshToken: user.refreshToken,
                        accessToken: accessToken,
                        username: user.displayName,
                        displayName: user.displayName,
                        email: user.email,
                    });

                    resolve()
                })
                .catch((err) => {
                    console.log("AXIOS ERROR: ", err);
                })       
            }).catch(function(error) {
                console.log("FIREBASE ERROR: ", error);
            });                         
        });         
    },
    [types.FETCH_PLAYER_DATA_ASYNC]: ({ commit, dispatch }, payload) => {        
        return new Promise((resolve, reject) => {
            axios.get(
                config.BASE_URL + "/playerdata",
                config.JSON_HEADER_CONFIG_BEARER(state.user.data.accessToken)
            )
            .then((res) => {
                console.log(res);
                if(res.data != null) {
                    commit(types.SET_PLAYER_DATA, res.data.map((elem) => {
                        return parsePlayerDataFromJSON(elem)
                    }));
                }
                resolve()
            })
            .catch((err) => {
                console.log("AXIOS ERROR: ", err);
            })
        });
    },
    [types.CREATE_PLAYER_DATA_ASYNC]: ({ commit, dispatch }, payload) => {
        return new Promise((resolve, reject) => {
            axios.post(
                config.BASE_URL + "/playerdata", 
                parsePlayerDataToJSON(config.getDefaultPlayerData()),
                config.JSON_HEADER_CONFIG_BEARER(state.user.data.accessToken)
            )
            .then((res) => {
                console.log(res);
                dispatch(types.FETCH_PLAYER_DATA_ASYNC)
                .then(function() {
                    resolve()
                })                
            })
            .catch((err) => {
                console.log("AXIOS ERROR: ", err);
            })
        });
    },
    [types.UPDATE_PLAYER_DATA_ASYNC]: ({ commit, dispatch }, payload) => {
        const updatedPlayerData = payload.updatedPlayerData;
        const index = payload.index;

        const parseUpdatedPlayerData = parsePlayerDataToJSON(updatedPlayerData)

        return new Promise((resolve, reject) => {
            axios.put(
                config.BASE_URL + "/playerdata", 
                parseUpdatedPlayerData,
                config.JSON_HEADER_CONFIG_BEARER(state.user.data.accessToken)
            )
            .then((res) => {
                console.log(res);
                const playerDatas = { ...state.user.playerDatas }
                playerDatas[index] = updatedPlayerData
                commit(types.SET_PLAYER_DATA, playerDatas)
                resolve()                
            })
            .catch((err) => {
                console.log("AXIOS ERROR: ", err);
            })
        });
    },
};

export default {
    state,
    getters,
    mutations,
    actions,
}